'use client';

import './child-bio.scss';

import {
  ChildAvailabilityItem,
  ChildDetails,
} from '@sola/schema/dotcom/children/child.js';

import { ChildBioDetails } from '../../molecules/child-bio-details/child-bio-details';
import { ChildBioImage } from '../../molecules/child-bio-image/child-bio-image';

export const ChildBioDisplay: React.FC<{
  details: ChildDetails;
  availability: ChildAvailabilityItem;
  seoLevel?: number;
}> = ({ seoLevel = 1, details, availability }) => {
  return (
    <div className="ChildBio__flex flex">
      <div className="ChildBio__media">
        <ChildBioImage details={details} availability={availability} />
      </div>
      <div className="ChildBio__content">
        <ChildBioDetails
          seoLevel={seoLevel}
          details={details}
          availability={availability}
        />
      </div>
    </div>
  );
};
